/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_Mock_4Inputs */

const en_cap_agents_mock_4 = /** @type {(inputs: Cap_Agents_Mock_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

const lv_cap_agents_mock_4 = /** @type {(inputs: Cap_Agents_Mock_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs`)
};

/**
* | output |
* | --- |
* | "You" |
*
* @param {Cap_Agents_Mock_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_mock_4 = /** @type {((inputs?: Cap_Agents_Mock_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_Mock_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_mock_4(inputs)
	return en_cap_agents_mock_4(inputs)
});